import { render, staticRenderFns } from "./ClientJbbfBaseInput.vue?vue&type=template&id=73607c2a&"
import script from "./ClientJbbfBaseInput.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBaseInput.vue?vue&type=script&lang=js&"
import style0 from "./ClientJbbfBaseInput.vue?vue&type=style&index=0&id=73607c2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports